export default __webpack_public_path__ + "static/media/ReportsPage-Header-Mobile.b503d4ff.jpg";